import { createContext } from "react";
const AnimationContext = createContext();

export const AnimationProvider = ({ children }) => {
  return (
    <AnimationContext.Provider
      value={{
        setAnimation: (inView) => {
          return {
            hidden: { y: 100, opacity: 0 },
            visible: {
              y: inView ? 0 : 100,
              opacity: inView ? 1 : 0,
              transition: {
                duration: 0.7,
                delay: 0.2,
                type: "tween",
                ease: "easeOut",
              },
            },
          };
        },
      }}
    >
      {children}
    </AnimationContext.Provider>
  );
};
export default AnimationContext;
